module.exports = __webpack_public_path__ + "static/media/workspaceInactive.e5be2572.png";